import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Redirect } from 'react-router-dom';
import {
	EuiImage,
	EuiPage,
	EuiPageBody,
	EuiPageSection,
	EuiPanel,
	EuiSpacer,
	EuiFlexGroup,
	EuiFlexItem,
	EuiButtonEmpty,
} from '@elastic/eui';
import PropTypes from 'prop-types';
import Logo from 'assets/images/logo_small.png';
import LogoHorizontal from 'assets/images/logo_horizontal.png';
import RitemedLogo from 'assets/images/ritemed.png';
import ContactInformation from 'components/ContactInformation';
import { registrationRxReference } from 'modules/auth/auth.actions';
import QualicareLogo from 'assets/images/qualicare-logo.png';

function AuthLayout({ children }) {
	const auth = useSelector((state) => state.auth);
	const history = useHistory();
	const dispatch = useDispatch();
	const [logo, setLogo] = useState({
		alt: 'MedAlert',
		url: Logo,
		size: 'm',
	});

	useEffect(() => {
		const { pathname } = history.location;
		switch (pathname) {
			case '/ritemed':
				setLogo({
					alt: 'RiteMed',
					url: RitemedLogo,
					size: 'm',
				});
				break;

			case '/login/qualicare':
				setLogo({
					alt: 'Qualicare',
					url: QualicareLogo,
					size: 'xl',
				});
				break;

			default:
				break;
		}
	}, []);

	if (auth.isLoggedIn) {
		const { state } = history.location;

		if (auth?.registrationRxReference) {
			dispatch(registrationRxReference(null));
		}

		const direction = state?.transactionData?.code
			? `/my-orders/validate/${state?.transactionData?.code}`
			: '/';

		return <Redirect to={direction} />;
	}

	return (
		<EuiPage
			className="registration-layout-container"
			data-testid="auth-layout-container"
		>
			<EuiPageBody
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<EuiPageSection
					style={{
						maxWidth: '500px',
						padding: '0',
					}}
				>
					<EuiPanel>
						<EuiSpacer />
						<EuiFlexGroup>
							<EuiFlexItem>
								<EuiImage
									alt={logo.alt}
									size={logo.size}
									url={logo.url}
								/>
							</EuiFlexItem>
						</EuiFlexGroup>
						<EuiPageSection>{children}</EuiPageSection>
					</EuiPanel>
				</EuiPageSection>
				<EuiPageSection
					style={{
						maxWidth: '500px',
						padding: '0',
					}}
				>
					<EuiPanel className="footer">
						<EuiFlexGroup
							direction="row"
							gutterSize="none"
							responsive={false}
							wrap
						>
							<EuiFlexItem>
								<EuiButtonEmpty
									color="primary"
									onClick={() => {
										history.push('/privacy-policy');
									}}
									size="xs"
								>
									Privacy Policy
								</EuiButtonEmpty>
							</EuiFlexItem>
							<EuiFlexItem>
								<EuiButtonEmpty
									color="primary"
									onClick={() => {
										history.push('/terms-and-conditions');
									}}
									size="xs"
								>
									Terms and Conditions
								</EuiButtonEmpty>
							</EuiFlexItem>
							<EuiFlexItem>
								<ContactInformation />
							</EuiFlexItem>
						</EuiFlexGroup>
					</EuiPanel>
				</EuiPageSection>
				{logo.alt !== 'MedAlert' && (
					<EuiPageSection
						style={{
							maxWidth: '500px',
							padding: '0',
						}}
					>
						<EuiPanel paddingSize="s">
							<EuiFlexGroup
								alignItems="center"
								direction="row"
								gutterSize="none"
								justifyContent="center"
								responsive={false}
							>
								<EuiFlexItem
									grow={false}
									style={{
										fontSize: '12.5px',
										fontWeight: '500',
										lineHeight: '1',
										color: '#0061a6',
										marginRight: '5px',
									}}
								>
									Powered by
								</EuiFlexItem>
								<EuiFlexItem grow={false}>
									<EuiImage
										alt="MedAlert"
										size="s"
										url={LogoHorizontal}
									/>
								</EuiFlexItem>
							</EuiFlexGroup>
						</EuiPanel>
					</EuiPageSection>
				)}
			</EuiPageBody>
		</EuiPage>
	);
}

AuthLayout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthLayout;
